module.exports = __webpack_public_path__ + "img/register.688c6d60.svg";